/**
 * Utility per il tracciamento degli eventi GA4
 */

export const GA_ID = 'G-9C0SWM6TVJ';

export const trackEvent = (eventName, position) => {
  const consent = localStorage.getItem('maaich-cookie-consent');
  
  if (consent === 'accepted' && window.gtag) {
    window.gtag('event', eventName, {
      'posizione': position,
      'event_category': 'conversion',
      'event_label': position
    });
    
    // Punto predisposto per tag conversione Google Ads
    // if (eventName === 'whatsapp_click') {
    //   window.gtag('event', 'conversion', {'send_to': 'AW-XXXXX/YYYYY'});
    // }
  }
};

export const initGA = () => {
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_ID}', { 'anonymize_ip': true });
  `;
  document.head.appendChild(script2);
};